{
  "login.meta.title": {
    "translation": "Log in — {{brandName}} Developer",
    "limit": 80
  },
  "login.meta.description": {
    "translation": "Log in to {{brandName}} Developer",
    "limit": 200
  },
  "login.heading": {
    "translation": "{{brandName}} Developer",
    "limit": 80,
    "note": "Main heading on the login form. {{brandName}} is interpolated at render time from the active brand (e.g. \"Foodpanda Developer\")."
  },
  "login.subtitle": {
    "translation": "Restaurant POS Integration Hub",
    "limit": 200
  },
  "nav.brand.label": {
    "translation": "{{brandName}} Developer",
    "limit": 60,
    "note": "Product wordmark shown in the authenticated app sidebar (expanded state). {{brandName}} is interpolated from the active brand."
  },
  "login.email.label": {
    "translation": "Work Email",
    "limit": 40
  },
  "login.email.placeholder": {
    "translation": "you@company.com",
    "limit": 70
  },
  "login.email.error.required": {
    "translation": "Email is required.",
    "limit": 120
  },
  "login.email.error.invalid": {
    "translation": "Enter a valid email address (e.g. you@company.com).",
    "limit": 120
  },
  "login.email.error.nonWork": {
    "translation": "Please use your corporate work email address.",
    "limit": 120
  },
  "login.password.label": {
    "translation": "Password",
    "limit": 40
  },
  "login.password.placeholder": {
    "translation": "Enter your password",
    "limit": 70
  },
  "login.password.show": {
    "translation": "Show password",
    "limit": 40
  },
  "login.password.hide": {
    "translation": "Hide password",
    "limit": 40
  },
  "login.password.error.required": {
    "translation": "Password is required.",
    "limit": 120
  },
  "login.password.error.incorrect": {
    "translation": "Incorrect password. Try again or reset it.",
    "limit": 120
  },
  "login.submit": {
    "translation": "Log In",
    "limit": 40
  },
  "login.submitting": {
    "translation": "Logging In...",
    "limit": 40
  },
  "login.cta.register": {
    "translation": "Apply for API Access",
    "limit": 60
  },
  "login.cta.existingPartner": {
    "translation": "Already integrated? Register here",
    "limit": 60,
    "note": "CTA link for VBO-integrated partners registering portal credentials for the first time"
  },
  "login.cta.forgotPassword": {
    "translation": "Forgot password?",
    "limit": 60
  },
  "login.error.locked": {
    "translation": "Too many failed attempts. Your account is locked for 15 minutes.",
    "limit": 120
  },
  "login.error.inactive": {
    "translation": "This account is no longer active. Contact support for assistance.",
    "limit": 120
  },
  "login.error.notFound": {
    "translation": "We don't recognise this email. Check for typos or apply for access.",
    "limit": 120
  },
  "login.error.invalidCredentials": {
    "translation": "Incorrect email or password. Try again or reset it.",
    "limit": 120
  },
  "login.error.networkFailure": {
    "translation": "Login failed. Check your connection and try again.",
    "limit": 120
  },
  "login.error.sessionExpired": {
    "translation": "Your session expired. Please log in again.",
    "limit": 120
  },
  "register.meta.title": {
    "translation": "Apply for API Access — {{brandName}} Developer",
    "limit": 80
  },
  "register.meta.description": {
    "translation": "Apply for API access to Delivery Hero POS systems.",
    "limit": 200
  },
  "register.heading": {
    "translation": "Apply for API Access",
    "limit": 80
  },
  "register.subtitle": {
    "translation": "Tell us about your company and the markets you operate in.",
    "limit": 200
  },
  "register.markets.label": {
    "translation": "Markets",
    "limit": 40
  },
  "register.markets.placeholder": {
    "translation": "Select markets",
    "limit": 70
  },
  "register.markets.selected": {
    "translation": "{{count}} markets selected",
    "limit": 80,
    "note": "Counter label for selected markets; {{count}} is a number"
  },
  "register.markets.search": {
    "translation": "Search countries",
    "limit": 80
  },
  "register.markets.editLabel": {
    "translation": "Edit markets selection",
    "limit": 80
  },
  "register.markets.apply": {
    "translation": "Apply",
    "limit": 40
  },
  "register.markets.error.required": {
    "translation": "Select at least one market.",
    "limit": 120
  },
  "register.firstName.label": {
    "translation": "First Name",
    "limit": 40
  },
  "register.firstName.placeholder": {
    "translation": "Jane",
    "limit": 70
  },
  "register.firstName.error.required": {
    "translation": "First name is required.",
    "limit": 120
  },
  "register.lastName.label": {
    "translation": "Last Name",
    "limit": 40
  },
  "register.lastName.placeholder": {
    "translation": "Smith",
    "limit": 70
  },
  "register.lastName.error.required": {
    "translation": "Last name is required.",
    "limit": 120
  },
  "register.email.label": {
    "translation": "Work Email",
    "limit": 40
  },
  "register.email.placeholder": {
    "translation": "you@company.com",
    "limit": 70
  },
  "register.email.error.required": {
    "translation": "Email is required.",
    "limit": 120
  },
  "register.email.error.invalid": {
    "translation": "Enter a valid email address (e.g. you@company.com).",
    "limit": 120
  },
  "register.email.error.nonWork": {
    "translation": "Please use your corporate work email address.",
    "limit": 120
  },
  "register.email.error.duplicate": {
    "translation": "An account with this email already exists. Log in instead?",
    "limit": 120
  },
  "register.phone.label": {
    "translation": "Phone",
    "limit": 40
  },
  "register.phone.placeholder": {
    "translation": "+1 555 123 4567",
    "limit": 70
  },
  "register.phone.helper": {
    "translation": "Include country code.",
    "limit": 200
  },
  "register.phone.error.required": {
    "translation": "Phone number is required.",
    "limit": 120
  },
  "register.company.label": {
    "translation": "Company Name",
    "limit": 40
  },
  "register.company.placeholder": {
    "translation": "Acme Corp",
    "limit": 70
  },
  "register.company.error.required": {
    "translation": "Company name is required.",
    "limit": 120
  },
  "register.website.label": {
    "translation": "Company Website",
    "limit": 40
  },
  "register.website.placeholder": {
    "translation": "https://acme.com",
    "limit": 70
  },
  "register.website.error.required": {
    "translation": "Company website is required.",
    "limit": 120
  },
  "register.website.error.invalid": {
    "translation": "Enter a valid URL starting with https:// (e.g. https://acme.com).",
    "limit": 120
  },
  "register.vendors.label": {
    "translation": "Number of Vendors",
    "limit": 40
  },
  "register.vendors.placeholder": {
    "translation": "Select a range",
    "limit": 70
  },
  "register.vendors.options.1_10": {
    "translation": "1–10",
    "limit": 10
  },
  "register.vendors.options.11_50": {
    "translation": "11–50",
    "limit": 10
  },
  "register.vendors.options.51_200": {
    "translation": "51–200",
    "limit": 10
  },
  "register.vendors.options.200plus": {
    "translation": "200+",
    "limit": 10
  },
  "register.vendors.error.required": {
    "translation": "Select the number of vendors you manage.",
    "limit": 120
  },
  "register.pgpKey.label": {
    "translation": "PGP Public Key",
    "limit": 40
  },
  "register.pgpKey.placeholder": {
    "translation": "-----BEGIN PGP PUBLIC KEY BLOCK-----",
    "limit": 70
  },
  "register.pgpKey.helper": {
    "translation": "Your PGP public key is used to encrypt your API credentials securely.",
    "limit": 200
  },
  "register.pgpKey.error.required": {
    "translation": "PGP public key is required.",
    "limit": 120
  },
  "register.terms.prefix": {
    "translation": "I agree to the ",
    "limit": 20,
    "note": "First part of 'I agree to the [Terms] and [Privacy]' — include trailing space"
  },
  "register.terms.termsLink": {
    "translation": "Terms & Conditions",
    "limit": 30
  },
  "register.terms.separator": {
    "translation": " and ",
    "limit": 20,
    "note": "Conjunction between Terms link and Privacy Policy link — include leading and trailing spaces"
  },
  "register.terms.privacyLink": {
    "translation": "Privacy Policy",
    "limit": 30
  },
  "register.terms.error.required": {
    "translation": "You must accept the Terms & Conditions to proceed.",
    "limit": 120
  },
  "register.submit": {
    "translation": "Submit Application",
    "limit": 40
  },
  "register.submitting": {
    "translation": "Submitting...",
    "limit": 40
  },
  "register.error.submissionFailed": {
    "translation": "Something went wrong submitting your application. Please try again.",
    "limit": 120
  },
  "register.cta.backToLogin": {
    "translation": "Back to Log In",
    "limit": 60
  },
  "register_confirm.meta.title": {
    "translation": "Check your email — {{brandName}} Developer",
    "limit": 80
  },
  "register_confirm.meta.description": {
    "translation": "We've sent you a verification email.",
    "limit": 200
  },
  "register_confirm.heading": {
    "translation": "Check your email",
    "limit": 80
  },
  "register_confirm.message": {
    "translation": "We sent a verification link to <strong>{{email}}</strong>. Click the link to verify your account and set your password.",
    "limit": 200,
    "note": "Confirmation body after registration; {{email}} is the user's email, <strong> tags are rendered as bold"
  },
  "register_confirm.cta.backToLogin": {
    "translation": "Back to Log In",
    "limit": 60
  },
  "existing_partner.meta.title": {
    "translation": "Existing Partner — {{brandName}} Developer",
    "limit": 80
  },
  "existing_partner.meta.description": {
    "translation": "Register as an existing Delivery Hero POS integration partner.",
    "limit": 200
  },
  "existing_partner.heading": {
    "translation": "Already integrated?",
    "limit": 80,
    "note": "Heading for existing VBO integration partners registering portal access"
  },
  "existing_partner.subtitle": {
    "translation": "Enter your registered work email and we'll send you a verification link.",
    "limit": 200
  },
  "existing_partner.email.label": {
    "translation": "Work Email",
    "limit": 40
  },
  "existing_partner.email.placeholder": {
    "translation": "you@company.com",
    "limit": 70
  },
  "existing_partner.email.helper": {
    "translation": "Use the email address registered during the original POS integration.",
    "limit": 200
  },
  "existing_partner.email.error.required": {
    "translation": "Email is required.",
    "limit": 120
  },
  "existing_partner.email.error.invalid": {
    "translation": "Enter a valid email address (e.g. you@company.com).",
    "limit": 120
  },
  "existing_partner.email.error.notFound": {
    "translation": "We couldn't find a match for this email. Check for typos or apply for access.",
    "limit": 120
  },
  "existing_partner.email.error.inactive": {
    "translation": "Your integration is currently inactive. You can access the portal in pending mode while we re-verify your status.",
    "limit": 120
  },
  "existing_partner.email.error.alreadySent": {
    "translation": "A verification link has already been sent. Check your inbox or wait before requesting a new one.",
    "limit": 120
  },
  "existing_partner.submit": {
    "translation": "Find my account",
    "limit": 40
  },
  "existing_partner.submitting": {
    "translation": "Searching...",
    "limit": 40
  },
  "existing_partner.success.sent": {
    "translation": "We've sent a verification link to {{email}}. Click it to set your password.",
    "limit": 160
  },
  "existing_partner.error.apiFailure": {
    "translation": "Something went wrong. Please try again or contact support.",
    "limit": 120
  },
  "existing_partner.error.rateLimited": {
    "translation": "Too many attempts. Please wait a few minutes before trying again.",
    "limit": 120
  },
  "existing_partner.cta.backToLogin": {
    "translation": "Back to Log In",
    "limit": 60
  },
  "existing_partner.cta.returnToLogin": {
    "translation": "Return to Login",
    "limit": 60
  },
  "set_password.meta.title": {
    "translation": "Set your password — {{brandName}} Developer",
    "limit": 80
  },
  "set_password.meta.description": {
    "translation": "Create a secure password for your {{brandName}} Developer account.",
    "limit": 200
  },
  "set_password.heading": {
    "translation": "Set your password",
    "limit": 80
  },
  "set_password.subtitle": {
    "translation": "Create a secure password to access your account.",
    "limit": 200
  },
  "set_password.password.label": {
    "translation": "New Password",
    "limit": 40
  },
  "set_password.password.placeholder": {
    "translation": "Enter your password",
    "limit": 70
  },
  "set_password.password.show": {
    "translation": "Show password",
    "limit": 40
  },
  "set_password.password.hide": {
    "translation": "Hide password",
    "limit": 40
  },
  "set_password.password.error.required": {
    "translation": "Password is required.",
    "limit": 120
  },
  "set_password.password.error.tooShort": {
    "translation": "Password must be at least 8 characters.",
    "limit": 120
  },
  "set_password.password.error.tooLong": {
    "translation": "Password must be 72 characters or fewer.",
    "limit": 120
  },
  "set_password.password.error.needsUppercase": {
    "translation": "Password must include at least one uppercase letter.",
    "limit": 120
  },
  "set_password.password.error.needsNumber": {
    "translation": "Password must include at least one number.",
    "limit": 120
  },
  "set_password.password.error.needsSpecial": {
    "translation": "Password must include at least one special character.",
    "limit": 120
  },
  "set_password.password.rules.length": {
    "translation": "At least 8 characters",
    "limit": 60
  },
  "set_password.password.rules.maxLength": {
    "translation": "72 characters or fewer",
    "limit": 60
  },
  "set_password.password.rules.uppercase": {
    "translation": "At least one uppercase letter",
    "limit": 60
  },
  "set_password.password.rules.number": {
    "translation": "At least one number",
    "limit": 60
  },
  "set_password.password.rules.special": {
    "translation": "At least one special character",
    "limit": 60
  },
  "set_password.confirmPassword.label": {
    "translation": "Confirm Password",
    "limit": 40
  },
  "set_password.confirmPassword.placeholder": {
    "translation": "Re-enter your password",
    "limit": 70
  },
  "set_password.confirmPassword.show": {
    "translation": "Show confirm password",
    "limit": 40
  },
  "set_password.confirmPassword.hide": {
    "translation": "Hide confirm password",
    "limit": 40
  },
  "set_password.confirmPassword.error.required": {
    "translation": "Please confirm your password.",
    "limit": 120
  },
  "set_password.confirmPassword.error.mismatch": {
    "translation": "Passwords do not match.",
    "limit": 120
  },
  "set_password.submit": {
    "translation": "Set Password & Login",
    "limit": 40
  },
  "set_password.submitting": {
    "translation": "Setting password...",
    "limit": 40
  },
  "set_password.error.tokenInvalid": {
    "translation": "This link is invalid or has already been used.",
    "limit": 120
  },
  "set_password.error.tokenExpired": {
    "translation": "This link has expired. Please request a new one.",
    "limit": 120
  },
  "forgot_password.meta.title": {
    "translation": "Reset your password — {{brandName}} Developer",
    "limit": 80
  },
  "forgot_password.meta.description": {
    "translation": "Request a password reset link for your {{brandName}} Developer account.",
    "limit": 200
  },
  "forgot_password.heading": {
    "translation": "Forgot your password?",
    "limit": 80
  },
  "forgot_password.subtitle": {
    "translation": "Enter your work email and we'll send you a reset link.",
    "limit": 200
  },
  "forgot_password.email.label": {
    "translation": "Work Email",
    "limit": 40
  },
  "forgot_password.email.placeholder": {
    "translation": "you@company.com",
    "limit": 70
  },
  "forgot_password.email.error.required": {
    "translation": "Email is required.",
    "limit": 120
  },
  "forgot_password.email.error.invalid": {
    "translation": "Enter a valid email address (e.g. you@company.com).",
    "limit": 120
  },
  "forgot_password.email.error.nonWork": {
    "translation": "Please use your corporate work email address.",
    "limit": 120
  },
  "forgot_password.submit": {
    "translation": "Send Reset Link",
    "limit": 40
  },
  "forgot_password.submitting": {
    "translation": "Sending...",
    "limit": 40
  },
  "forgot_password.sent.message": {
    "translation": "If this email is registered, you'll receive a reset link shortly.",
    "limit": 200
  },
  "forgot_password.sent.resend": {
    "translation": "Send another link",
    "limit": 40
  },
  "forgot_password.sent.cooldown": {
    "translation": "You can resend in {{seconds}} seconds.",
    "limit": 80
  },
  "forgot_password.cta.backToLogin": {
    "translation": "Back to Log In",
    "limit": 60
  },
  "link_expired.meta.title": {
    "translation": "Link expired — {{brandName}} Developer",
    "limit": 80
  },
  "link_expired.meta.description": {
    "translation": "Your verification link has expired.",
    "limit": 200
  },
  "link_expired.heading": {
    "translation": "Link expired",
    "limit": 80,
    "note": "Shown when the email verification or invite link has expired or already been used"
  },
  "link_expired.message": {
    "translation": "Your verification link has expired or is invalid. Request a new link below.",
    "limit": 200
  },
  "link_expired.resend.submit": {
    "translation": "Request a New Link",
    "limit": 40
  },
  "link_expired.resend.submitting": {
    "translation": "Sending...",
    "limit": 40
  },
  "link_expired.resend.sent": {
    "translation": "A new link has been sent to your email address.",
    "limit": 160
  },
  "link_expired.resend.cooldown": {
    "translation": "You can request a new link in {{seconds}} seconds.",
    "limit": 80
  },
  "link_expired.cta.backToLogin": {
    "translation": "Back to Log In",
    "limit": 60
  },
  "app_nav.dashboard": {
    "translation": "Dashboard",
    "limit": 20
  },
  "app_nav.credentials": {
    "translation": "Credentials",
    "limit": 20
  },
  "app_nav.vendors": {
    "translation": "Partners",
    "limit": 20
  },
  "app_nav.docs": {
    "translation": "Documentation",
    "limit": 20
  },
  "app_nav.more": {
    "translation": "More",
    "limit": 20
  },
  "app_nav.support": {
    "translation": "Support",
    "limit": 20
  },
  "app_nav.logout": {
    "translation": "Log Out",
    "limit": 20
  },
  "app_nav.lockedTooltip": {
    "translation": "Available after application approval",
    "limit": 60,
    "note": "Tooltip on navigation items unavailable before account approval"
  },
  "app_nav.collapseNav": {
    "translation": "Collapse navigation",
    "limit": 60
  },
  "app_nav.expandNav": {
    "translation": "Expand navigation",
    "limit": 60
  },
  "pending_dashboard.meta.title": {
    "translation": "Application Pending — {{brandName}} Developer",
    "limit": 80
  },
  "pending_dashboard.meta.description": {
    "translation": "Your application is under review.",
    "limit": 200
  },
  "pending_dashboard.alert.info.heading": {
    "translation": "Application pending review",
    "limit": 80
  },
  "pending_dashboard.alert.info.submittedAt": {
    "translation": "Submitted on {{date}}",
    "limit": 80
  },
  "pending_dashboard.alert.neutral.message": {
    "translation": "Support options are limited until your application is approved.",
    "limit": 200
  },
  "pending_dashboard.welcome": {
    "translation": "Welcome, {{name}}",
    "limit": 80
  },
  "pending_dashboard.body": {
    "translation": "Your application for <strong>{{email}}</strong> is under review. This usually takes 2–3 business days. We'll notify you by email once a decision has been made.",
    "limit": 200,
    "note": "Review explanation body; {{email}} is the user's email, <strong> tags are rendered as bold"
  },
  "pending_dashboard.cta.checkStatus": {
    "translation": "Check Status",
    "limit": 60
  },
  "pending_dashboard.cta.support": {
    "translation": "Contact Support",
    "limit": 60
  },
  "active_dashboard.meta.title": {
    "translation": "Dashboard — {{brandName}} Developer",
    "limit": 80
  },
  "active_dashboard.meta.description": {
    "translation": "Your account is approved and active.",
    "limit": 200
  },
  "active_dashboard.alert.success": {
    "translation": "Your account is approved and active. Welcome to {{brandName}} Developer.",
    "limit": 160
  },
  "active_dashboard.welcome": {
    "translation": "Welcome back, {{name}}",
    "limit": 80
  },
  "active_dashboard.subtitle": {
    "translation": "{{company}} · {{email}}",
    "limit": 200,
    "note": "Sub-header showing company and email — {{company}} and {{email}} are interpolated"
  },
  "active_dashboard.tag": {
    "translation": "Approved · {{date}}",
    "limit": 40,
    "note": "Approval status badge — format 'Approved · {{date}}'; preserve the · separator"
  },
  "active_dashboard.quickAccess.heading": {
    "translation": "Quick access",
    "limit": 80
  },
  "active_dashboard.quickAccess.open": {
    "translation": "Open",
    "limit": 40
  },
  "active_dashboard.quickAccess.credentials.label": {
    "translation": "API Credentials",
    "limit": 40
  },
  "active_dashboard.quickAccess.credentials.description": {
    "translation": "View and rotate your API key and chain code.",
    "limit": 120
  },
  "active_dashboard.quickAccess.vendors.label": {
    "translation": "Partners",
    "limit": 40
  },
  "active_dashboard.quickAccess.vendors.description": {
    "translation": "Manage connected vendors and onboard new ones.",
    "limit": 120
  },
  "active_dashboard.quickAccess.support.label": {
    "translation": "Support",
    "limit": 40
  },
  "active_dashboard.quickAccess.support.description": {
    "translation": "Open tickets and track issue resolution.",
    "limit": 120
  },
  "active_dashboard.quickAccess.docs.label": {
    "translation": "API Docs",
    "limit": 40
  },
  "active_dashboard.quickAccess.docs.description": {
    "translation": "Browse middleware and plugin endpoint references.",
    "limit": 120
  },
  "support.meta.title": {
    "translation": "Support — {{brandName}} Developer",
    "limit": 80
  },
  "support.meta.description": {
    "translation": "View and manage your support tickets.",
    "limit": 200
  },
  "support.heading": {
    "translation": "Support",
    "limit": 80
  },
  "support.newTicket": {
    "translation": "Create New Request",
    "limit": 80
  },
  "support.submitted": {
    "translation": "Ticket {{id}} submitted. We'll be in touch within 3–5 business days.",
    "limit": 160,
    "note": "Confirmation after ticket creation; {{id}} is the ticket ID"
  },
  "support.empty.heading": {
    "translation": "No tickets yet",
    "limit": 80
  },
  "support.empty.message": {
    "translation": "Open a ticket if you need help with your integration.",
    "limit": 200
  },
  "support.table.id": {
    "translation": "ID",
    "limit": 30
  },
  "support.table.subject": {
    "translation": "Subject",
    "limit": 30
  },
  "support.table.category": {
    "translation": "Category",
    "limit": 30
  },
  "support.table.status": {
    "translation": "Status",
    "limit": 30
  },
  "support.table.lastActivity": {
    "translation": "Last activity",
    "limit": 30
  },
  "support.status.open": {
    "translation": "Open",
    "limit": 20
  },
  "support.status.in_progress": {
    "translation": "In Progress",
    "limit": 20
  },
  "support.status.closed": {
    "translation": "Closed",
    "limit": 20
  },
  "support.category.application_status": {
    "translation": "Application Status",
    "limit": 60
  },
  "support.category.technical_question": {
    "translation": "Technical Question",
    "limit": 60
  },
  "support.category.other": {
    "translation": "Other",
    "limit": 60
  },
  "support.category.credentials": {
    "translation": "Credentials",
    "limit": 60
  },
  "support.category.vendor_onboarding": {
    "translation": "Vendor Onboarding",
    "limit": 60
  },
  "support.category.orders": {
    "translation": "Orders",
    "limit": 60
  },
  "support.category.catalog": {
    "translation": "Catalog",
    "limit": 60
  },
  "support.new.heading": {
    "translation": "New Support Request",
    "limit": 80
  },
  "support.new.brand.label": {
    "translation": "Brand",
    "limit": 40
  },
  "support.new.brand.placeholder": {
    "translation": "Select brand",
    "limit": 70
  },
  "support.new.brand.error.required": {
    "translation": "Brand is required.",
    "limit": 120
  },
  "support.new.relatedVendor.label": {
    "translation": "Related Vendor",
    "limit": 40
  },
  "support.new.relatedVendor.optional": {
    "translation": "(optional)",
    "limit": 20
  },
  "support.new.subject.label": {
    "translation": "Subject",
    "limit": 40
  },
  "support.new.subject.placeholder": {
    "translation": "Briefly describe your issue",
    "limit": 70
  },
  "support.new.subject.error.required": {
    "translation": "Subject is required.",
    "limit": 120
  },
  "support.new.category.label": {
    "translation": "Category",
    "limit": 40
  },
  "support.new.category.placeholder": {
    "translation": "Select a category",
    "limit": 70
  },
  "support.new.category.error.required": {
    "translation": "Category is required.",
    "limit": 120
  },
  "support.new.message.label": {
    "translation": "Description",
    "limit": 40
  },
  "support.new.message.placeholder": {
    "translation": "Describe your issue in detail (min 20 characters)...",
    "limit": 70
  },
  "support.new.message.error.required": {
    "translation": "Description is required.",
    "limit": 120
  },
  "support.new.message.error.tooShort": {
    "translation": "Description must be at least 20 characters.",
    "limit": 120
  },
  "support.new.submit": {
    "translation": "Submit Ticket",
    "limit": 40
  },
  "support.new.submitting": {
    "translation": "Submitting...",
    "limit": 40
  },
  "support.new.cancel": {
    "translation": "Cancel",
    "limit": 40
  },
  "support.new.submitError": {
    "translation": "We couldn't submit your request. Your draft has been saved.",
    "limit": 160
  },
  "support.new.download": {
    "translation": "Download your request",
    "limit": 40
  },
  "support.new.draft.restored": {
    "translation": "You have a saved draft from a previous session.",
    "limit": 160
  },
  "support.new.draft.discard": {
    "translation": "Discard",
    "limit": 40
  },
  "support.detail.heading": {
    "translation": "Support Ticket",
    "limit": 80
  },
  "support.detail.label.status": {
    "translation": "Status",
    "limit": 80
  },
  "support.detail.label.id": {
    "translation": "Ticket",
    "limit": 80
  },
  "support.detail.label.brand": {
    "translation": "Brand",
    "limit": 80
  },
  "support.detail.label.category": {
    "translation": "Category",
    "limit": 80
  },
  "support.detail.label.created": {
    "translation": "Created",
    "limit": 80
  },
  "support.detail.label.lastActivity": {
    "translation": "Last activity",
    "limit": 80
  },
  "support.detail.label.message": {
    "translation": "Description",
    "limit": 200
  },
  "support.detail.label.relatedVendors": {
    "translation": "Related Vendors",
    "limit": 80
  },
  "support.detail.thread.heading": {
    "translation": "Activity",
    "limit": 80
  },
  "support.detail.thread.systemRole": {
    "translation": "System",
    "limit": 30
  },
  "support.detail.thread.systemEvent": {
    "translation": "Ticket opened",
    "limit": 30
  },
  "support.detail.thread.supportRole": {
    "translation": "Support Team",
    "limit": 30
  },
  "support.detail.thread.partnerRole": {
    "translation": "You",
    "limit": 30
  },
  "support.detail.thread.mockReply": {
    "translation": "Thank you for reaching out. We are reviewing your request and will get back to you within 3–5 business days.",
    "limit": 200,
    "note": "Placeholder reply shown in ticket thread for demo purposes"
  },
  "support.detail.reply.label": {
    "translation": "Reply",
    "limit": 40
  },
  "support.detail.reply.placeholder": {
    "translation": "Type your reply...",
    "limit": 70
  },
  "support.detail.reply.submit": {
    "translation": "Send reply",
    "limit": 40
  },
  "support.detail.reply.sending": {
    "translation": "Sending...",
    "limit": 40
  },
  "support.detail.reply.errorToast": {
    "translation": "Reply failed. Try again.",
    "limit": 80
  },
  "support.detail.closed.note": {
    "translation": "This ticket is closed. No further replies can be added.",
    "limit": 80
  },
  "support.detail.close": {
    "translation": "Close",
    "limit": 40
  },
  "support.onboarding.detail.meta.title": {
    "translation": "Vendor Onboarding Request — {{brandName}} Developer",
    "limit": 80
  },
  "support.onboarding.detail.heading": {
    "translation": "Vendor Onboarding Request",
    "limit": 80
  },
  "support.onboarding.detail.label.jiraIssueKey": {
    "translation": "Ticket",
    "limit": 40
  },
  "support.onboarding.detail.label.vendorGroup": {
    "translation": "Vendor Group",
    "limit": 40
  },
  "support.onboarding.detail.label.vendorCode": {
    "translation": "Vendor Code",
    "limit": 40
  },
  "support.onboarding.detail.label.submittedOn": {
    "translation": "Submitted",
    "limit": 40
  },
  "support.onboarding.detail.label.lastUpdated": {
    "translation": "Last updated",
    "limit": 40
  },
  "support.onboarding.detail.section.activity": {
    "translation": "Activity",
    "limit": 40
  },
  "support.onboarding.detail.empty.activity": {
    "translation": "No updates yet — VBO will respond here.",
    "limit": 120
  },
  "support.onboarding.status.pending": {
    "translation": "Pending VBO review",
    "limit": 40
  },
  "support.onboarding.status.inactive": {
    "translation": "Awaiting connection",
    "limit": 40
  },
  "support.onboarding.status.rejected": {
    "translation": "Rejected",
    "limit": 40
  },
  "vendors.meta.title": {
    "translation": "Connected Partners — {{brandName}} Developer",
    "limit": 80
  },
  "vendors.meta.description": {
    "translation": "View and manage your connected vendors across all platforms.",
    "limit": 200
  },
  "vendors.heading": {
    "translation": "Connected Partners",
    "limit": 80
  },
  "vendors.addVendor": {
    "translation": "+ Add Vendor",
    "limit": 80
  },
  "vendors.addSuccess": {
    "translation": "Vendor {{vendorId}} submitted successfully. Status: PENDING.",
    "limit": 160,
    "note": "Confirmation after vendor submission; {{vendorId}} is the submitted vendor ID"
  },
  "vendors.statusNote": {
    "translation": "Status updates every ~60 seconds.",
    "limit": 200,
    "note": "Note that the vendor list refreshes automatically every ~60 seconds"
  },
  "vendors.pendingSubmissions": {
    "translation": "Pending Submissions",
    "limit": 60,
    "note": "Group heading for vendor onboarding rows whose VBO confirmation is not yet received"
  },
  "vendors.empty": {
    "translation": "No vendors match your search.",
    "limit": 80
  },
  "vendors.search.placeholder": {
    "translation": "Search by Remote ID...",
    "limit": 70
  },
  "vendors.filter.integration": {
    "translation": "Integration",
    "limit": 80
  },
  "vendors.filter.vendorGroup": {
    "translation": "Vendor Group",
    "limit": 80
  },
  "vendors.filter.clearAll": {
    "translation": "Clear all",
    "limit": 80
  },
  "vendors.add.heading": {
    "translation": "Add Vendor",
    "limit": 80
  },
  "vendors.add.close": {
    "translation": "Close drawer",
    "limit": 40
  },
  "vendors.add.platform.label": {
    "translation": "Platform",
    "limit": 40
  },
  "vendors.add.platform.placeholder": {
    "translation": "Select a platform",
    "limit": 70
  },
  "vendors.add.country.label": {
    "translation": "Country",
    "limit": 40
  },
  "vendors.add.country.placeholder": {
    "translation": "Select a country",
    "limit": 70
  },
  "vendors.add.country.placeholderNoPlatform": {
    "translation": "Select a platform first",
    "limit": 70
  },
  "vendors.add.vendorCode.label": {
    "translation": "Vendor Code",
    "limit": 40
  },
  "vendors.add.vendorCode.placeholder": {
    "translation": "e.g. 12345",
    "limit": 70
  },
  "vendors.add.vendorCode.helper": {
    "translation": "Code provided by the vendor or your {{brandName}} contact.",
    "limit": 200,
    "note": "Helper text below the vendor code field. {{brandName}} is interpolated at render time from the active brand (e.g. \"Foodpanda\")."
  },
  "vendors.add.vendorCode.error.required": {
    "translation": "Vendor code is required.",
    "limit": 120
  },
  "vendors.add.preview.label": {
    "translation": "Vendor ID to be submitted:",
    "limit": 40
  },
  "vendors.add.submit": {
    "translation": "Submit Vendor",
    "limit": 40
  },
  "vendors.add.submitting": {
    "translation": "Submitting...",
    "limit": 40
  },
  "vendors.add.error.duplicate": {
    "translation": "This vendor is already connected to your account.",
    "limit": 120
  },
  "vendors.add.error.unavailable": {
    "translation": "The onboarding service is temporarily unavailable. Please try again later.",
    "limit": 120
  },
  "vendors.add.error.submission": {
    "translation": "Something went wrong. Please try again.",
    "limit": 120
  },
  "vendors.add.cancel": {
    "translation": "Cancel",
    "limit": 40
  },
  "vendors.status.active": {
    "translation": "Active",
    "limit": 20
  },
  "vendors.status.inactive": {
    "translation": "Inactive",
    "limit": 20
  },
  "vendors.status.pending": {
    "translation": "Pending",
    "limit": 20
  },
  "vendors.status.rejected": {
    "translation": "Rejected",
    "limit": 20
  },
  "credentials.meta.title": {
    "translation": "API Credentials — {{brandName}} Developer",
    "limit": 80
  },
  "credentials.meta.description": {
    "translation": "View and manage your API credentials for DH POS integration.",
    "limit": 200
  },
  "credentials.heading": {
    "translation": "API Credentials",
    "limit": 80
  },
  "credentials.subtitle": {
    "translation": "Use these credentials to authenticate your integration with DH POS APIs.",
    "limit": 200
  },
  "credentials.copied": {
    "translation": "Copied to clipboard",
    "limit": 80
  },
  "credentials.apiKey.label": {
    "translation": "Production API Key",
    "limit": 40
  },
  "credentials.apiKey.tag": {
    "translation": "Production",
    "limit": 40
  },
  "credentials.apiKey.reveal": {
    "translation": "Reveal",
    "limit": 40
  },
  "credentials.apiKey.hide": {
    "translation": "Hide ({{countdown}}s)",
    "limit": 40,
    "note": "Button shown while the API key is visible; {{countdown}} = seconds remaining until auto-hide"
  },
  "credentials.apiKey.hidesIn": {
    "translation": "Hides in {{countdown}}s",
    "limit": 80,
    "note": "Inline countdown shown next to the visible API key; {{countdown}} = seconds remaining"
  },
  "credentials.apiKey.copy": {
    "translation": "Copy Key",
    "limit": 40
  },
  "credentials.apiKey.warning": {
    "translation": "Keep this key secure. Never share it or commit it to source code.",
    "limit": 200,
    "note": "Security reminder shown below the revealed API key"
  },
  "credentials.chainCode.label": {
    "translation": "Chain Code",
    "limit": 40
  },
  "credentials.chainCode.copy": {
    "translation": "Copy Chain Code",
    "limit": 40
  },
  "credentials.rotation.heading": {
    "translation": "Need to rotate your API key?",
    "limit": 80
  },
  "credentials.rotation.body": {
    "translation": "Submit a support request. Key rotation is handled by the DH team.",
    "limit": 200,
    "note": "Explanation of the manual key rotation process via support ticket"
  },
  "credentials.rotation.cta": {
    "translation": "Create Support request",
    "limit": 80
  },
  "lang_selector.label": {
    "translation": "Language",
    "limit": 20
  },
  "lang_selector.en": {
    "translation": "English",
    "limit": 30
  },
  "lang_selector.ar": {
    "translation": "Arabic",
    "limit": 30
  },
  "lang_selector.tr": {
    "translation": "Turkish",
    "limit": 30
  },
  "error.401.heading": {
    "translation": "Session expired",
    "limit": 120
  },
  "error.401.message": {
    "translation": "Your session has expired. Please log in again.",
    "limit": 120
  },
  "error.403.heading": {
    "translation": "Access denied",
    "limit": 120
  },
  "error.403.message": {
    "translation": "You do not have permission to view this page.",
    "limit": 120
  },
  "error.404.heading": {
    "translation": "Page not found",
    "limit": 120
  },
  "error.404.message": {
    "translation": "The page you are looking for does not exist.",
    "limit": 120
  },
  "error.default.heading": {
    "translation": "Something went wrong",
    "limit": 120
  },
  "error.default.message": {
    "translation": "An unexpected error occurred. Please try again.",
    "limit": 120
  },
  "lang_selector.es": {
    "translation": "Spanish (Latin America)",
    "limit": 30
  },
  "lang_selector.es-ES": {
    "translation": "Spanish (Spain)",
    "limit": 30
  },
  "auth_nav.backToLogin": {
    "translation": "Back to Log In",
    "limit": 30
  },
  "vendors.add.integration.label": {
    "translation": "Integration",
    "limit": 40
  },
  "vendors.add.integration.placeholder": {
    "translation": "Select an integration",
    "limit": 70
  },
  "vendors.add.noIntegrations": {
    "translation": "No integrations are linked to your account yet. Please contact support to set up your integration before adding vendors.",
    "limit": 200
  },
  "vendors.add.vendorGroup.label": {
    "translation": "Vendor Group",
    "limit": 40
  },
  "vendors.add.vendorGroup.placeholder": {
    "translation": "Select a vendor group",
    "limit": 70
  },
  "vendors.add.vendorGroup.placeholderNoIntegration": {
    "translation": "Select an integration first",
    "limit": 70,
    "note": "Shown in vendor group dropdown when no integration has been selected yet"
  },
  "vendors.add.vendorGroup.helper": {
    "translation": "Not sure of your vendor group? Contact your {{brandName}} account manager.",
    "limit": 200,
    "note": "Helper text below the vendor group field. {{brandName}} is interpolated at render time from the active brand (e.g. \"Foodpanda\")."
  },
  "vendors.add.posVendorId.label": {
    "translation": "Remote Vendor ID",
    "limit": 40
  },
  "vendors.add.posVendorId.placeholder": {
    "translation": "e.g. KFC_001",
    "limit": 70
  },
  "vendors.add.posVendorId.helper": {
    "translation": "POS Vendor ID in your system.",
    "limit": 200
  },
  "vendors.add.posVendorId.error.required": {
    "translation": "Remote Vendor ID is required.",
    "limit": 120
  },
  "docs.endpoint.authHeaderDesc": {
    "translation": "Bearer token obtained from the Authentication endpoint. Format:",
    "limit": 120
  },
  "docs.endpoint.bodyDefaultDesc": {
    "translation": "JSON payload. See the code example for the expected structure.",
    "limit": 120
  },
  "docs.endpoint.contentTypeDesc": {
    "translation": "Must be",
    "limit": 40
  },
  "docs.endpoint.deprecated": {
    "translation": "This endpoint is deprecated.",
    "limit": 80
  },
  "docs.endpoint.deprecatedInstead": {
    "translation": "instead.",
    "limit": 40
  },
  "docs.endpoint.deprecatedUse": {
    "translation": "Use",
    "limit": 20
  },
  "docs.endpoint.dynamicUrlBody": {
    "translation": "This endpoint uses a URL registered during integration setup — it is not a literal path.",
    "limit": 200
  },
  "docs.endpoint.dynamicUrlTitle": {
    "translation": "Dynamic callback URL",
    "limit": 40
  },
  "docs.endpoint.paramColDesc": {
    "translation": "Description",
    "limit": 30
  },
  "docs.endpoint.paramColName": {
    "translation": "Parameter",
    "limit": 30
  },
  "docs.endpoint.pathParams": {
    "translation": "Path Parameters",
    "limit": 30
  },
  "docs.endpoint.queryParams": {
    "translation": "Query Parameters",
    "limit": 30
  },
  "docs.endpoint.requestBody": {
    "translation": "Request Body",
    "limit": 30
  },
  "docs.endpoint.requestHeaders": {
    "translation": "Request Headers",
    "limit": 30
  },
  "docs.endpoint.required": {
    "translation": "required",
    "limit": 20
  },
  "docs.endpoint.responseSample": {
    "translation": "Response",
    "limit": 30
  },
  "docs.endpoint.responses": {
    "translation": "Responses",
    "limit": 30
  },
  "docs.endpoint.codeTab.curl": {
    "translation": "cURL",
    "limit": 20
  },
  "docs.endpoint.codeTab.js": {
    "translation": "JavaScript",
    "limit": 20
  },
  "docs.endpoint.jsComment.replaceBody": {
    "translation": "Replace with your actual request body",
    "limit": 80,
    "note": "Code comment in the JavaScript code example block on endpoint detail pages; the // prefix is added in code"
  },
  "docs.meta.home.title": {
    "translation": "API Reference — {{brandName}} Developer",
    "limit": 80
  },
  "docs.meta.detail.titleFallback": {
    "translation": "Documentation",
    "limit": 40
  },
  "docs.meta.titleTemplate": {
    "translation": "{{title}} — {{brandName}} Developer",
    "limit": 80,
    "note": "Template for docs page titles; {{title}} is the dynamic page name"
  },
  "docs.heading": {
    "translation": "API Reference & Developer Guides",
    "limit": 80
  },
  "docs.menuClose": {
    "translation": "Close navigation menu",
    "limit": 40
  },
  "docs.menuCloseLabel": {
    "translation": "CLOSE",
    "limit": 20
  },
  "docs.menuOpen": {
    "translation": "Open navigation menu",
    "limit": 40
  },
  "docs.menuOpenLabel": {
    "translation": "MENU",
    "limit": 20
  },
  "docs.nav.aria": {
    "translation": "API documentation sections",
    "limit": 40
  },
  "docs.searchPlaceholder": {
    "translation": "Search endpoints and guides...",
    "limit": 70
  },
  "docs.sectionMeta.endpoints_one": {
    "translation": "{{count}} endpoint",
    "limit": 30
  },
  "docs.sectionMeta.endpoints_other": {
    "translation": "{{count}} endpoints",
    "limit": 30
  },
  "docs.sectionMeta.guides_one": {
    "translation": "{{count}} guide",
    "limit": 30
  },
  "docs.sectionMeta.guides_other": {
    "translation": "{{count}} guides",
    "limit": 30
  },
  "docs.subtitle": {
    "translation": "Complete reference for the POS Middleware and Plugin APIs. Integrate directly with Delivery Hero's ordering infrastructure.",
    "limit": 200
  },
  "docs.version": {
    "translation": "POS API",
    "limit": 20
  },
  "support.new.relatedVendor.placeholder": {
    "translation": "Select vendors",
    "limit": 70
  },
  "support.new.relatedVendor.search": {
    "translation": "Search vendors",
    "limit": 60
  },
  "support.new.relatedVendor.more": {
    "translation": "+{{count}} more",
    "limit": 20,
    "note": "Appended to vendor trigger text when more than 2 vendors are selected; {{count}} is a number"
  },
  "support.new.relatedVendor.noResults": {
    "translation": "No vendors match your search.",
    "limit": 80
  },
  "support.filter.status": {
    "translation": "Status",
    "limit": 30
  },
  "support.filter.category": {
    "translation": "Category",
    "limit": 30
  },
  "support.filter.date": {
    "translation": "Date",
    "limit": 30
  },
  "support.filter.date.last_7_days": {
    "translation": "Last 7 days",
    "limit": 30
  },
  "support.filter.date.last_30_days": {
    "translation": "Last 30 days",
    "limit": 30
  },
  "support.filter.date.last_90_days": {
    "translation": "Last 90 days",
    "limit": 30
  },
  "support.filter.clearAll": {
    "translation": "Clear all",
    "limit": 30
  },
  "support.filter.empty": {
    "translation": "No tickets match your filters.",
    "limit": 60
  },
  "docs.content.sections.guides.title": {
    "translation": "Getting Started",
    "limit": 60
  },
  "docs.content.sections.guides.description": {
    "translation": "Prerequisites, API access setup, and step-by-step process overview.",
    "limit": 200
  },
  "docs.content.sections.middleware.title": {
    "translation": "POS Middleware API",
    "limit": 60
  },
  "docs.content.sections.middleware.description": {
    "translation": "Partner → Delivery Hero. Use these endpoints to manage orders, vendors, and catalog.",
    "limit": 200
  },
  "docs.content.sections.plugin.title": {
    "translation": "POS Plugin API",
    "limit": 60
  },
  "docs.content.sections.plugin.description": {
    "translation": "Delivery Hero → Partner. Implement these endpoints in your system to receive orders and updates.",
    "limit": 200
  },
  "docs.content.sections.reference.title": {
    "translation": "Reference",
    "limit": 60
  },
  "docs.content.sections.reference.description": {
    "translation": "Order management flows, catalog management, store management, terminology, FAQ, and post-production agreement.",
    "limit": 200
  },
  "docs.content.nav.guides.getting-started.title": {
    "translation": "Prerequisites & Process Overview",
    "limit": 60
  },
  "docs.content.nav.guides.access-integration.title": {
    "translation": "Access & Integration Setup",
    "limit": 60
  },
  "docs.content.nav.middleware.authentication.token.title": {
    "translation": "Authentication",
    "limit": 60
  },
  "docs.content.nav.middleware.orders.create.title": {
    "translation": "Create Order",
    "limit": 60
  },
  "docs.content.nav.middleware.orders.update-status.title": {
    "translation": "Update Order Status",
    "limit": 60
  },
  "docs.content.nav.middleware.orders.get.title": {
    "translation": "Get Order",
    "limit": 60
  },
  "docs.content.nav.middleware.vendors.availability.title": {
    "translation": "Vendor Availability",
    "limit": 60
  },
  "docs.content.nav.middleware.vendors.info.title": {
    "translation": "Vendor Information",
    "limit": 60
  },
  "docs.content.nav.middleware.catalog.import.title": {
    "translation": "Trigger Catalog Import",
    "limit": 60
  },
  "docs.content.nav.middleware.catalog.item-availability.title": {
    "translation": "Item Availability",
    "limit": 60
  },
  "docs.content.nav.middleware.reports.order-reporting.title": {
    "translation": "Order Reporting",
    "limit": 60
  },
  "docs.content.nav.middleware.orders.create-legacy.title": {
    "translation": "Create Order (v1)",
    "limit": 60
  },
  "docs.content.nav.plugin.orders.dispatch.title": {
    "translation": "Dispatch Order",
    "limit": 60
  },
  "docs.content.nav.plugin.orders.update-status.title": {
    "translation": "Update Order Status",
    "limit": 60
  },
  "docs.content.nav.plugin.catalog.menu-import.title": {
    "translation": "Trigger Menu Import",
    "limit": 60
  },
  "docs.content.nav.plugin.catalog.import-callback.title": {
    "translation": "Catalog Import Callback",
    "limit": 60
  },
  "docs.content.nav.reference.order-management.title": {
    "translation": "Order Management",
    "limit": 60
  },
  "docs.content.nav.reference.catalog-management.title": {
    "translation": "Catalog Management",
    "limit": 60
  },
  "docs.content.nav.reference.store-management.title": {
    "translation": "Store Management",
    "limit": 60
  },
  "docs.content.nav.reference.order-report-service.title": {
    "translation": "Order Report Service",
    "limit": 60
  },
  "docs.content.nav.reference.terminology.title": {
    "translation": "Terminology",
    "limit": 60
  },
  "docs.content.nav.reference.faq.title": {
    "translation": "Frequently Asked Questions",
    "limit": 60
  },
  "docs.content.nav.reference.post-production.title": {
    "translation": "Post-Production Agreement",
    "limit": 60
  },
  "docs.content.response.400.label": {
    "translation": "Bad Request",
    "limit": 40
  },
  "docs.content.response.400.description": {
    "translation": "The request body or query parameters failed validation.",
    "limit": 120
  },
  "docs.content.response.401.label": {
    "translation": "Unauthorized",
    "limit": 40
  },
  "docs.content.response.401.description": {
    "translation": "The Bearer token is missing, expired, or has been revoked.",
    "limit": 120
  },
  "docs.content.response.500.label": {
    "translation": "Internal Server Error",
    "limit": 40
  },
  "docs.content.response.500.description": {
    "translation": "An unexpected server error occurred. Retry with exponential back-off.",
    "limit": 160
  },
  "docs.content.ep.middleware.authentication.token.title": {
    "translation": "Authentication",
    "limit": 60
  },
  "docs.content.ep.middleware.authentication.token.description": {
    "translation": "Exchange your client credentials for a short-lived Bearer token. Include this token in the Authorization header of every subsequent request.",
    "limit": 200
  },
  "docs.content.ep.middleware.authentication.token.body": {
    "translation": "JSON payload with `username` and `password` (your Integration Middleware credentials).",
    "limit": 160
  },
  "docs.content.ep.middleware.authentication.token.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.middleware.authentication.token.r200.description": {
    "translation": "Access token issued successfully.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.create.title": {
    "translation": "Create Order",
    "limit": 60
  },
  "docs.content.ep.middleware.orders.create.description": {
    "translation": "Create a new order in the POS system. The order is queued for preparation immediately upon creation.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.create.body": {
    "translation": "Order payload including line items, vendor ID, and fulfilment data.",
    "limit": 160
  },
  "docs.content.ep.middleware.orders.create.r201.label": {
    "translation": "Created",
    "limit": 40
  },
  "docs.content.ep.middleware.orders.create.r201.description": {
    "translation": "Order created successfully.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.update-status.title": {
    "translation": "Update Order Status",
    "limit": 60
  },
  "docs.content.ep.middleware.orders.update-status.description": {
    "translation": "Update the lifecycle status of an existing order. Valid transitions depend on the current state of the order.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.update-status.body": {
    "translation": "Status transition payload. Accepted values: `ACCEPTED`, `REJECTED`, `PREPARED`, `PICKED_UP`.",
    "limit": 160
  },
  "docs.content.ep.middleware.orders.update-status.param.orderId": {
    "translation": "The unique identifier of the order.",
    "limit": 160
  },
  "docs.content.ep.middleware.orders.update-status.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.middleware.orders.update-status.r200.description": {
    "translation": "Status updated successfully.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.get.title": {
    "translation": "Get Order",
    "limit": 60
  },
  "docs.content.ep.middleware.orders.get.description": {
    "translation": "Retrieve full details of a single order including its line items, status history, and fulfilment data.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.get.param.orderId": {
    "translation": "The unique identifier of the order.",
    "limit": 160
  },
  "docs.content.ep.middleware.orders.get.query.include": {
    "translation": "Comma-separated fields to expand. Accepted values: items, history, customer",
    "limit": 160
  },
  "docs.content.ep.middleware.orders.get.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.middleware.orders.get.r200.description": {
    "translation": "Order returned successfully.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.create-legacy.title": {
    "translation": "Create Order (v1)",
    "limit": 60
  },
  "docs.content.ep.middleware.orders.create-legacy.description": {
    "translation": "Deprecated. Creates an order using the legacy v1 request schema. Migrate to Create Order at your earliest opportunity.",
    "limit": 200
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.label": {
    "translation": "Created",
    "limit": 40
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.description": {
    "translation": "Order created using the legacy schema.",
    "limit": 200
  },
  "docs.content.ep.middleware.vendors.availability.title": {
    "translation": "Vendor Availability",
    "limit": 60
  },
  "docs.content.ep.middleware.vendors.availability.description": {
    "translation": "Toggle a vendor open or closed. When closed, the vendor is hidden from the customer-facing ordering surface.",
    "limit": 200
  },
  "docs.content.ep.middleware.vendors.availability.body": {
    "translation": "Availability payload. `{ \"available\": true | false }`",
    "limit": 160
  },
  "docs.content.ep.middleware.vendors.availability.param.vendorId": {
    "translation": "The unique identifier of the vendor.",
    "limit": 160
  },
  "docs.content.ep.middleware.vendors.availability.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.middleware.vendors.availability.r200.description": {
    "translation": "Availability updated successfully.",
    "limit": 200
  },
  "docs.content.ep.middleware.vendors.info.title": {
    "translation": "Vendor Information",
    "limit": 60
  },
  "docs.content.ep.middleware.vendors.info.description": {
    "translation": "Fetch profile details for a vendor including physical address, cuisine type, and opening hours.",
    "limit": 200
  },
  "docs.content.ep.middleware.vendors.info.param.vendorId": {
    "translation": "The unique identifier of the vendor.",
    "limit": 160
  },
  "docs.content.ep.middleware.vendors.info.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.middleware.vendors.info.r200.description": {
    "translation": "Vendor profile returned successfully.",
    "limit": 200
  },
  "docs.content.ep.middleware.catalog.import.title": {
    "translation": "Trigger Catalog Import",
    "limit": 60
  },
  "docs.content.ep.middleware.catalog.import.description": {
    "translation": "Trigger an asynchronous catalog sync from your POS system. Returns immediately with a job ID you can use to track progress.",
    "limit": 200
  },
  "docs.content.ep.middleware.catalog.import.body": {
    "translation": "Catalog payload with menu items, categories, and optional callback URL for import status notifications.",
    "limit": 160
  },
  "docs.content.ep.middleware.catalog.import.r202.label": {
    "translation": "Accepted",
    "limit": 40
  },
  "docs.content.ep.middleware.catalog.import.r202.description": {
    "translation": "Catalog import queued for processing.",
    "limit": 200
  },
  "docs.content.ep.middleware.catalog.item-availability.title": {
    "translation": "Item Availability",
    "limit": 60
  },
  "docs.content.ep.middleware.catalog.item-availability.description": {
    "translation": "Enable or disable individual menu items in real time — useful for 86'ing items that are temporarily unavailable.",
    "limit": 200
  },
  "docs.content.ep.middleware.catalog.item-availability.body": {
    "translation": "`{ \"available\": true | false }`",
    "limit": 160
  },
  "docs.content.ep.middleware.catalog.item-availability.param.itemId": {
    "translation": "The unique identifier of the catalog item.",
    "limit": 160
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.description": {
    "translation": "Item availability updated successfully.",
    "limit": 200
  },
  "docs.content.ep.middleware.reports.order-reporting.title": {
    "translation": "Order Reporting",
    "limit": 60
  },
  "docs.content.ep.middleware.reports.order-reporting.description": {
    "translation": "Retrieve aggregated order statistics and revenue metrics for a specified date range and set of vendors.",
    "limit": 200
  },
  "docs.content.ep.middleware.reports.order-reporting.query.from": {
    "translation": "Report start date. Example: 2024-01-01T00:00:00Z",
    "limit": 160
  },
  "docs.content.ep.middleware.reports.order-reporting.query.to": {
    "translation": "Report end date. Example: 2024-01-31T23:59:59Z",
    "limit": 160
  },
  "docs.content.ep.middleware.reports.order-reporting.query.vendorId": {
    "translation": "Filter to a specific vendor. Omit for all vendors.",
    "limit": 160
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.description": {
    "translation": "Report data returned successfully.",
    "limit": 200
  },
  "docs.content.ep.plugin.orders.dispatch.title": {
    "translation": "Dispatch Order",
    "limit": 60
  },
  "docs.content.ep.plugin.orders.dispatch.description": {
    "translation": "Delivery Hero pushes a new customer order to your POS system. Respond with HTTP 200 to acknowledge receipt.",
    "limit": 200
  },
  "docs.content.ep.plugin.orders.dispatch.body": {
    "translation": "Full order payload from Delivery Hero including line items, customer details, and delivery information.",
    "limit": 160
  },
  "docs.content.ep.plugin.orders.dispatch.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.plugin.orders.dispatch.r200.description": {
    "translation": "Order acknowledged. Must respond within 5 seconds or the order is retried.",
    "limit": 200
  },
  "docs.content.ep.plugin.orders.dispatch.r500.label": {
    "translation": "Internal Server Error",
    "limit": 40
  },
  "docs.content.ep.plugin.orders.dispatch.r500.description": {
    "translation": "Indicates the plugin could not process the order. Delivery Hero will retry.",
    "limit": 200
  },
  "docs.content.ep.plugin.orders.update-status.title": {
    "translation": "Update Order Status",
    "limit": 60
  },
  "docs.content.ep.plugin.orders.update-status.description": {
    "translation": "Delivery Hero notifies your system of an order status change originating from the DH platform.",
    "limit": 200
  },
  "docs.content.ep.plugin.orders.update-status.body": {
    "translation": "Status change payload including order ID and new status.",
    "limit": 160
  },
  "docs.content.ep.plugin.orders.update-status.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.plugin.orders.update-status.r200.description": {
    "translation": "Status update acknowledged.",
    "limit": 200
  },
  "docs.content.ep.plugin.orders.update-status.r500.label": {
    "translation": "Internal Server Error",
    "limit": 40
  },
  "docs.content.ep.plugin.orders.update-status.r500.description": {
    "translation": "Delivery Hero will retry the notification.",
    "limit": 200
  },
  "docs.content.ep.plugin.catalog.menu-import.title": {
    "translation": "Trigger Menu Import",
    "limit": 60
  },
  "docs.content.ep.plugin.catalog.menu-import.description": {
    "translation": "Delivery Hero requests a fresh menu export from your POS system to trigger a catalog synchronization.",
    "limit": 200
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.description": {
    "translation": "Menu import triggered. Follow up with a Submit Catalog Import call.",
    "limit": 200
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.label": {
    "translation": "Internal Server Error",
    "limit": 40
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.description": {
    "translation": "Delivery Hero will retry the request.",
    "limit": 200
  },
  "docs.content.ep.plugin.catalog.import-callback.title": {
    "translation": "Catalog Import Callback",
    "limit": 60
  },
  "docs.content.ep.plugin.catalog.import-callback.description": {
    "translation": "Your endpoint receives the outcome of a catalog import job previously triggered by Delivery Hero.",
    "limit": 200
  },
  "docs.content.ep.plugin.catalog.import-callback.body": {
    "translation": "Import result payload with status (SUCCESS | FAILURE) and error details if applicable.",
    "limit": 160
  },
  "docs.content.ep.plugin.catalog.import-callback.param.catalogImportCallback": {
    "translation": "Your callback URL registered with Delivery Hero during integration setup. Delivery Hero POSTs the import result to this URL.",
    "limit": 160
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.label": {
    "translation": "OK",
    "limit": 40
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.description": {
    "translation": "Callback received and acknowledged.",
    "limit": 200
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.label": {
    "translation": "Internal Server Error",
    "limit": 40
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.description": {
    "translation": "Delivery Hero will retry the callback.",
    "limit": 200
  },
  "docs.content.guide.getting-started.title": {
    "translation": "Getting Started",
    "limit": 80
  },
  "docs.content.guide.getting-started.b0.text": {
    "translation": "Prerequisites",
    "limit": 80
  },
  "docs.content.guide.getting-started.b1.text": {
    "translation": "Before beginning development, please ensure you have completed the following:",
    "limit": 200
  },
  "docs.content.guide.getting-started.b2.i0": {
    "translation": "Completed a Non-Disclosure Agreement with Delivery Hero. If you do not have one, reach out to your Delivery Hero platform contact.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b2.i1": {
    "translation": "Received confirmation from your Delivery Hero platform contact to begin development.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b3.text": {
    "translation": "Process Overview",
    "limit": 80
  },
  "docs.content.guide.getting-started.b4.text": {
    "translation": "The end-to-end integration process follows these eight steps:",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i0.title": {
    "translation": "Request access",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i0.body": {
    "translation": "Request access to Delivery Hero's Integration APIs by submitting a credential request.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i1.title": {
    "translation": "Set up a test integration",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i1.body": {
    "translation": "Configure your staging integration with the details provided by your Delivery Hero contact.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i2.title": {
    "translation": "Begin development",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i2.body": {
    "translation": "Implement the required Middleware and Plugin API endpoints in your POS system.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i3.title": {
    "translation": "Perform end-to-end testing",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i3.body": {
    "translation": "Test the full order flow with your Delivery Hero platform contact before going live.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i4.title": {
    "translation": "Set up your production integration",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i4.body": {
    "translation": "Replicate the staging integration configuration in the production environment.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i5.title": {
    "translation": "Set up and launch pilot vendor(s)",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i5.body": {
    "translation": "Onboard your first vendors and monitor the integration for stability.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i6.title": {
    "translation": "Continue setting up vendors",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i6.body": {
    "translation": "Progressively onboard additional vendors using the same configuration pattern.",
    "limit": 200
  },
  "docs.content.guide.getting-started.b5.i7.title": {
    "translation": "Maintain integration",
    "limit": 80
  },
  "docs.content.guide.getting-started.b5.i7.body": {
    "translation": "Monitor the integration health and adopt new API features as they are released.",
    "limit": 200
  },
  "docs.content.guide.access-integration.title": {
    "translation": "Access & Integration Setup",
    "limit": 80
  },
  "docs.content.guide.access-integration.b0.text": {
    "translation": "Getting Access",
    "limit": 80
  },
  "docs.content.guide.access-integration.b1.text": {
    "translation": "To get access to the Integration APIs, you will need a credential (username and password). Follow these steps:",
    "limit": 200
  },
  "docs.content.guide.access-integration.b2.i0.title": {
    "translation": "Submit a credential request",
    "limit": 80
  },
  "docs.content.guide.access-integration.b2.i0.body": {
    "translation": "Generate a PGP key pair — your PGP public key is required to encrypt the credential before sending it to you. Then fill in the aggregator credential request form and submit it.",
    "limit": 400
  },
  "docs.content.guide.access-integration.b2.i1.title": {
    "translation": "Let your platform contact know",
    "limit": 80
  },
  "docs.content.guide.access-integration.b2.i1.body": {
    "translation": "After submitting the request, notify your Delivery Hero platform contact so they can review and approve it.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b2.i2.title": {
    "translation": "Receive credential via email",
    "limit": 80
  },
  "docs.content.guide.access-integration.b2.i2.body": {
    "translation": "You will receive the credential via email once your platform contact approves the request. Check your spam folder if you do not see it.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b2.i3.title": {
    "translation": "Decrypt the credential",
    "limit": 80
  },
  "docs.content.guide.access-integration.b2.i3.body": {
    "translation": "Use your PGP private key to decrypt the credential message.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b2.i4.title": {
    "translation": "Get an access token",
    "limit": 80
  },
  "docs.content.guide.access-integration.b2.i4.body": {
    "translation": "Use the Authentication endpoint to exchange your credential for a Bearer token. This token is required on every subsequent API call.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b3.text": {
    "translation": "Setting Up Your Integration",
    "limit": 80
  },
  "docs.content.guide.access-integration.b4.text": {
    "translation": "Staging environments must be used for all development and testing. Never test against the production environment.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b5.text": {
    "translation": "Understanding Integrations, Chains, and Vendors",
    "limit": 80
  },
  "docs.content.guide.access-integration.b6.i0.term": {
    "translation": "Vendor",
    "limit": 80
  },
  "docs.content.guide.access-integration.b6.i0.def": {
    "translation": "A single restaurant location operating on the Delivery Hero platform.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b6.i1.term": {
    "translation": "Chain",
    "limit": 80
  },
  "docs.content.guide.access-integration.b6.i1.def": {
    "translation": "A restaurant chain consisting of one or more vendors that typically share the same restaurant name but operate from different physical locations.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b6.i2.term": {
    "translation": "Integration",
    "limit": 80
  },
  "docs.content.guide.access-integration.b6.i2.def": {
    "translation": "A plugin built by you to programmatically manage orders, menus, and stores on the Delivery Hero platform. An integration consists of one or more chains.",
    "limit": 400
  },
  "docs.content.guide.access-integration.b7.text": {
    "translation": "Relationships and Constraints",
    "limit": 80
  },
  "docs.content.guide.access-integration.b8.i0": {
    "translation": "An integration consists of one or more chains.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b8.i1": {
    "translation": "A chain consists of one or more vendors.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b8.i2": {
    "translation": "Vendors can only belong to one unique chain and integration.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b9.text": {
    "translation": "Integration Configuration Fields",
    "limit": 80
  },
  "docs.content.guide.access-integration.b10.text": {
    "translation": "Provide the following information to your Delivery Hero platform contact to activate your integration:",
    "limit": 200
  },
  "docs.content.guide.access-integration.b11.h0": {
    "translation": "Field",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.h1": {
    "translation": "Definition",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.h2": {
    "translation": "Naming Convention / Example",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r0.c0": {
    "translation": "Integration Name",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r0.c1": {
    "translation": "Name of your integration.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r0.c2": {
    "translation": "Company name and country — e.g. Acme Germany",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r1.c0": {
    "translation": "Integration Code",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r1.c1": {
    "translation": "Unique key for your integration.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r1.c2": {
    "translation": "company-name-countrycode — e.g. acme-de",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r2.c0": {
    "translation": "Base URL",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r2.c1": {
    "translation": "Base URL of your plugin used to receive order dispatch and status notifications. An SSL certificate is required.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b11.r2.c2": {
    "translation": "https://pos.yourcompany.com",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r3.c0": {
    "translation": "Plugin Username",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r3.c1": {
    "translation": "Username of your credential.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r3.c2": {
    "translation": "Provided during credential setup",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r4.c0": {
    "translation": "Chain Name",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r4.c1": {
    "translation": "Name of a restaurant chain.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r4.c2": {
    "translation": "Chain name and country — e.g. Pizza Palace Germany",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r5.c0": {
    "translation": "Chain Code",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r5.c1": {
    "translation": "Unique key for the restaurant chain.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r5.c2": {
    "translation": "chain-name-countrycode — e.g. pizzapalace-de",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r6.c0": {
    "translation": "Vendor Code",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r6.c1": {
    "translation": "Identifier of the vendor. Request from your restaurant contact.",
    "limit": 200
  },
  "docs.content.guide.access-integration.b11.r6.c2": {
    "translation": "Numeric — e.g. 12345",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r7.c0": {
    "translation": "Country",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r7.c1": {
    "translation": "Country the vendor belongs to.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r7.c2": {
    "translation": "ISO 3166-1 alpha-2 — e.g. DE",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r8.c0": {
    "translation": "Remote ID",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r8.c1": {
    "translation": "A unique identifier for the vendor in your plugin.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r8.c2": {
    "translation": "Your internal vendor identifier",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r9.c0": {
    "translation": "Integration Flow",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r9.c1": {
    "translation": "Order integration flow type.",
    "limit": 80
  },
  "docs.content.guide.access-integration.b11.r9.c2": {
    "translation": "Direct or Indirect",
    "limit": 80
  },
  "docs.content.guide.access-integration.b12.text": {
    "translation": "IP Address Whitelist",
    "limit": 80
  },
  "docs.content.guide.access-integration.b13.text": {
    "translation": "To receive orders from the Integration Middleware, your plugin must whitelist the following IP addresses:",
    "limit": 200
  },
  "docs.content.guide.access-integration.b14.h0": {
    "translation": "Region / Environment",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.h1": {
    "translation": "Public IP Addresses",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r0.c0": {
    "translation": "Latin America",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r0.c1": {
    "translation": "54.161.200.26\n54.174.130.155\n18.204.190.239",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r1.c0": {
    "translation": "Europe",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r1.c1": {
    "translation": "63.32.162.210\n34.255.237.245\n63.32.145.112",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r2.c0": {
    "translation": "Middle East + Turkey",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r2.c1": {
    "translation": "63.32.225.161\n18.202.96.85\n52.208.41.152",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r3.c0": {
    "translation": "Asia Pacific",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r3.c1": {
    "translation": "3.0.217.166\n3.1.134.42\n3.1.56.76",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r4.c0": {
    "translation": "Staging environment",
    "limit": 80
  },
  "docs.content.guide.access-integration.b14.r4.c1": {
    "translation": "34.246.34.27\n18.202.142.208\n54.72.10.41",
    "limit": 80
  },
  "docs.content.guide.order-management.title": {
    "translation": "Order Management",
    "limit": 80
  },
  "docs.content.guide.order-management.b0.text": {
    "translation": "Use the Order Management API to manage incoming orders from the Delivery Hero platform. There are two integration flows — choose based on whether you equip vendors with Delivery Hero devices.",
    "limit": 400
  },
  "docs.content.guide.order-management.b1.text": {
    "translation": "Indirect Integration",
    "limit": 80
  },
  "docs.content.guide.order-management.b2.text": {
    "translation": "The vendor is equipped with a Delivery Hero vendor device to manage incoming orders. The device handles order acceptance; the integration forwards accepted orders to your POS system.",
    "limit": 400
  },
  "docs.content.guide.order-management.b3.i0.body": {
    "translation": "Customer places an order at a vendor on the Delivery Hero platform.",
    "limit": 200
  },
  "docs.content.guide.order-management.b3.i1.body": {
    "translation": "Delivery Hero pushes the order to the Delivery Hero vendor application used by the vendor.",
    "limit": 200
  },
  "docs.content.guide.order-management.b3.i2.body": {
    "translation": "Employee accepts the order on the Delivery Hero vendor application (auto-accept can be enabled — ask your platform contact).",
    "limit": 200
  },
  "docs.content.guide.order-management.b3.i3.body": {
    "translation": "Accepted order is pushed to Integration Middleware, which forwards it to your plugin.",
    "limit": 200
  },
  "docs.content.guide.order-management.b3.i4.body": {
    "translation": "Plugin forwards the accepted order to your POS system.",
    "limit": 80
  },
  "docs.content.guide.order-management.b4.text": {
    "translation": "Direct Integration",
    "limit": 80
  },
  "docs.content.guide.order-management.b5.text": {
    "translation": "The vendor uses their own POS system to process incoming orders — no Delivery Hero vendor device is required.",
    "limit": 200
  },
  "docs.content.guide.order-management.b6.i0.body": {
    "translation": "Customer places an order on the Delivery Hero platform.",
    "limit": 80
  },
  "docs.content.guide.order-management.b6.i1.body": {
    "translation": "Delivery Hero pushes the order to Integration Middleware, which forwards it to your plugin.",
    "limit": 200
  },
  "docs.content.guide.order-management.b6.i2.body": {
    "translation": "Plugin forwards the order to your POS system.",
    "limit": 80
  },
  "docs.content.guide.order-management.b6.i3.body": {
    "translation": "Employee accepts or rejects the order via your POS system. Auto-accept can be implemented in the plugin.",
    "limit": 200
  },
  "docs.content.guide.order-management.b7.text": {
    "translation": "Comparison",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.h0": {
    "translation": "",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.h1": {
    "translation": "Indirect Integration",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.h2": {
    "translation": "Direct Integration",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r0.c0": {
    "translation": "Order Management",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r0.c1": {
    "translation": "Vendor manages orders via Delivery Hero vendor app. Accepted orders are forwarded to your POS.",
    "limit": 200
  },
  "docs.content.guide.order-management.b8.r0.c2": {
    "translation": "Vendor manages orders entirely via their own POS system.",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r1.c0": {
    "translation": "Auto-Acceptance",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r1.c1": {
    "translation": "Can be enabled on the Delivery Hero vendor device — contact your platform contact.",
    "limit": 200
  },
  "docs.content.guide.order-management.b8.r1.c2": {
    "translation": "Can be implemented directly in the plugin.",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r2.c0": {
    "translation": "Plugin Development Effort",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r2.c1": {
    "translation": "Minimum. Required endpoint: Order Dispatch webhook.",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r2.c2": {
    "translation": "Higher. Required endpoints: Update Order Status, Order Dispatch, Order Status Update.",
    "limit": 200
  },
  "docs.content.guide.order-management.b8.r3.c0": {
    "translation": "Fallback",
    "limit": 80
  },
  "docs.content.guide.order-management.b8.r3.c1": {
    "translation": "If plugin is unavailable, vendor continues using the Delivery Hero vendor app.",
    "limit": 200
  },
  "docs.content.guide.order-management.b8.r3.c2": {
    "translation": "If plugin is unavailable, unacknowledged orders are cancelled after a timeout.",
    "limit": 200
  },
  "docs.content.guide.catalog-management.title": {
    "translation": "Catalog Management",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b0.text": {
    "translation": "Use the Catalog Management API to manage your menu on the Delivery Hero platform. You can sync menus and control individual item availability in real time.",
    "limit": 400
  },
  "docs.content.guide.catalog-management.b1.text": {
    "translation": "Catalog Import Flow",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b2.i0.title": {
    "translation": "Plugin calls Submit Catalog",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b2.i0.body": {
    "translation": "Send the full catalog payload to Integration Middleware synchronously.",
    "limit": 200
  },
  "docs.content.guide.catalog-management.b2.i1.title": {
    "translation": "Integration Middleware validates",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b2.i1.body": {
    "translation": "Middleware performs a short validation and acknowledges the request synchronously.",
    "limit": 200
  },
  "docs.content.guide.catalog-management.b2.i2.title": {
    "translation": "Platform update (async)",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b2.i2.body": {
    "translation": "Middleware validates the full catalog and forwards it to the Delivery Hero platform to update the menu.",
    "limit": 200
  },
  "docs.content.guide.catalog-management.b2.i3.title": {
    "translation": "Status notification (async)",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b2.i3.body": {
    "translation": "If a callback URL was provided in the submit request, Middleware notifies your plugin of the import status.",
    "limit": 200
  },
  "docs.content.guide.catalog-management.b2.i4.title": {
    "translation": "Retrieve import status (optional)",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b2.i4.body": {
    "translation": "You can also poll the Catalog Import Log endpoint to check the status of a specific import job.",
    "limit": 200
  },
  "docs.content.guide.catalog-management.b3.text": {
    "translation": "Catalog Import for Centralized Kitchen",
    "limit": 80
  },
  "docs.content.guide.catalog-management.b4.text": {
    "translation": "For vendors operating a centralized kitchen or sharing a POS system across brands, individual menu imports per vendor must be submitted — not a single bulk import. The same catalog import flow applies.",
    "limit": 400
  },
  "docs.content.guide.catalog-management.b5.text": {
    "translation": "Contact your Delivery Hero platform contact if you need a test vendor for centralized kitchen integration development.",
    "limit": 200
  },
  "docs.content.guide.store-management.title": {
    "translation": "Store Management",
    "limit": 80
  },
  "docs.content.guide.store-management.b0.text": {
    "translation": "Use the Store Management API to manage the availability of vendors on the Delivery Hero platform. Available functionality:",
    "limit": 200
  },
  "docs.content.guide.store-management.b1.i0.term": {
    "translation": "Update Vendor Availability",
    "limit": 80
  },
  "docs.content.guide.store-management.b1.i0.def": {
    "translation": "Toggle a vendor open or closed. When closed, the vendor is removed from the customer-facing ordering surface.",
    "limit": 200
  },
  "docs.content.guide.store-management.b1.i1.term": {
    "translation": "Vendor Availability (Plugin endpoint)",
    "limit": 80
  },
  "docs.content.guide.store-management.b1.i1.def": {
    "translation": "Delivery Hero notifies your system of vendor availability status changes originating from the platform side.",
    "limit": 200
  },
  "docs.content.guide.order-report-service.title": {
    "translation": "Order Report Service",
    "limit": 80
  },
  "docs.content.guide.order-report-service.b0.text": {
    "translation": "Use the Order Report Service to retrieve completed orders and aggregated order statistics. Available functionality:",
    "limit": 200
  },
  "docs.content.guide.order-report-service.b1.i0.term": {
    "translation": "Order IDs",
    "limit": 80
  },
  "docs.content.guide.order-report-service.b1.i0.def": {
    "translation": "Retrieve order identifiers for orders completed in the last 24 hours.",
    "limit": 200
  },
  "docs.content.guide.order-report-service.b1.i1.term": {
    "translation": "Order Detail",
    "limit": 80
  },
  "docs.content.guide.order-report-service.b1.i1.def": {
    "translation": "Retrieve the full detail of a specific completed order.",
    "limit": 80
  },
  "docs.content.guide.order-report-service.b1.i2.term": {
    "translation": "Order Reporting",
    "limit": 80
  },
  "docs.content.guide.order-report-service.b1.i2.def": {
    "translation": "Retrieve aggregated order statistics and revenue metrics for a specified date range and vendor set.",
    "limit": 200
  },
  "docs.content.guide.terminology.title": {
    "translation": "Terminology",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i0.term": {
    "translation": "POS Clients",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i0.def": {
    "translation": "Chains or POS providers who receive orders from Delivery Hero directly on their POS system.",
    "limit": 200
  },
  "docs.content.guide.terminology.b0.i1.term": {
    "translation": "Vendors",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i1.def": {
    "translation": "Physical locations where food is prepared.",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i2.term": {
    "translation": "POS System",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i2.def": {
    "translation": "Point-of-sale software on the POS Client's side that compiles online and offline orders and transactions.",
    "limit": 200
  },
  "docs.content.guide.terminology.b0.i3.term": {
    "translation": "Integration Middleware",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i3.def": {
    "translation": "Delivery Hero's order transmission system responsible for forwarding orders placed on Delivery Hero platforms to the Vendor's POS system.",
    "limit": 200
  },
  "docs.content.guide.terminology.b0.i4.term": {
    "translation": "Plugin",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i4.def": {
    "translation": "An adapter built by the POS Client to programmatically manage orders, menus, and stores on the Delivery Hero platform.",
    "limit": 200
  },
  "docs.content.guide.terminology.b0.i5.term": {
    "translation": "Delivery Hero Vendor App",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i5.def": {
    "translation": "A Delivery Hero application for vendors where orders placed on a Delivery Hero platform can be processed (accepted or rejected).",
    "limit": 200
  },
  "docs.content.guide.terminology.b0.i6.term": {
    "translation": "Platform Vendor ID",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i6.def": {
    "translation": "An identifier of a restaurant on the Delivery Hero platform. Also known as the vendor code.",
    "limit": 200
  },
  "docs.content.guide.terminology.b0.i7.term": {
    "translation": "Remote ID",
    "limit": 80
  },
  "docs.content.guide.terminology.b0.i7.def": {
    "translation": "A unique identifier of the vendor in your plugin.",
    "limit": 80
  },
  "docs.content.guide.faq.title": {
    "translation": "Frequently Asked Questions",
    "limit": 80
  },
  "docs.content.guide.faq.b0.text": {
    "translation": "Why is an SSL certificate required?",
    "limit": 80
  },
  "docs.content.guide.faq.b1.text": {
    "translation": "An SSL certificate on your plugin's web server is required to ensure secure communication between Integration Middleware and your plugin.",
    "limit": 200
  },
  "docs.content.guide.faq.b2.text": {
    "translation": "Which IP addresses must my plugin whitelist?",
    "limit": 80
  },
  "docs.content.guide.faq.b3.text": {
    "translation": "All Integration Middleware IP addresses are listed in the Access & Integration Setup guide under IP Address Whitelist.",
    "limit": 200
  },
  "docs.content.guide.faq.b4.text": {
    "translation": "Is a base URL with a port number allowed?",
    "limit": 80
  },
  "docs.content.guide.faq.b5.text": {
    "translation": "Yes. Base URLs with port numbers (e.g. https://pos.anydomain.com:3154) are supported.",
    "limit": 200
  },
  "docs.content.guide.faq.b6.text": {
    "translation": "How do I map product IDs between my POS system and the Delivery Hero platform?",
    "limit": 200
  },
  "docs.content.guide.faq.b7.text": {
    "translation": "Mapping is achieved via the Submit Catalog endpoint — include your remote product codes in the catalog payload. If your plugin does not implement this endpoint, contact your Delivery Hero platform contact for manual product mapping.",
    "limit": 400
  },
  "docs.content.guide.faq.b8.text": {
    "translation": "What are the image requirements for menu items?",
    "limit": 80
  },
  "docs.content.guide.faq.b9.text": {
    "translation": "Image requirements are defined in the platform-specific API documentation. Contact your Delivery Hero platform contact for the exact specifications for your market.",
    "limit": 400
  },
  "docs.content.guide.post-production.title": {
    "translation": "Post-Production Agreement",
    "limit": 80
  },
  "docs.content.guide.post-production.b0.text": {
    "translation": "By going live on the Delivery Hero platform, plugin maintainers agree to the following obligations:",
    "limit": 200
  },
  "docs.content.guide.post-production.b1.i0.body": {
    "translation": "Inform Delivery Hero of upcoming system maintenance at least 24 hours in advance by emailing the designated support channel.",
    "limit": 200
  },
  "docs.content.guide.post-production.b1.i1.body": {
    "translation": "Provide contact details that Delivery Hero can use to escalate technical issues with the plugin outside business hours.",
    "limit": 200
  },
  "docs.content.guide.post-production.b1.i2.body": {
    "translation": "The integration may be disabled by Delivery Hero if a technical issue with the plugin is not resolved within the agreed SLA and provided contact details are unreachable.",
    "limit": 400
  },
  "docs.content.guide.post-production.b1.i3.body": {
    "translation": "Some features or the entire integration may be disabled if certain implementation articles are incomplete.",
    "limit": 200
  },
  "docs.content.guide.post-production.b2.text": {
    "translation": "Common Missing Implementation Points",
    "limit": 80
  },
  "docs.content.guide.post-production.b3.i0": {
    "translation": "Working cancellation endpoint on the plugin side (required for Direct Integration to receive cancelled order notifications).",
    "limit": 200
  },
  "docs.content.guide.post-production.b3.i1": {
    "translation": "Rejecting an order while not providing a valid reject reason (see the Update Order Status endpoint for the list of valid reason codes).",
    "limit": 200
  },
  "docs.content.guide.post-production.b3.i2": {
    "translation": "Accepting an order with an incorrectly formatted datetime (see the Update Order Status endpoint for the required datetime format).",
    "limit": 200
  },
  "docs.content.guide.post-production.b3.i3": {
    "translation": "Providing a plugin endpoint that cannot be validated — ensure your SSL certificate is valid and the endpoint responds to curl requests.",
    "limit": 200
  }
}
